module.exports = __webpack_public_path__ + "static/media/deliverAgentIco1.9149e44f.svg";